import { useQueryClient } from 'react-query';
import { IEHSagaContext } from './sagaContext';

export const useSagaContext = (): IEHSagaContext => {
  const queryClient = useQueryClient();
  return { queryClient };
};
